import { VoiceOption } from '@/domain/voice-and-language-options';

// https://microsoft.azure.com/en-us/services/cognitive-services/text-to-speech/#overview
export const PROVIDERS = ['azure', 'mvoice'];

// list of azure voices:
// https://learn.microsoft.com/en-us/azure/ai-services/speech-service/language-support?tabs=tts

export const VOICE_OPTIONS: VoiceOption[] = [
    {
        label: 'حمدان (Hamdan) - AE',
        value: {
            language: 'ar-AE',
            voice: 'ar-AE-HamdanNeural',
            provider: 'azure',
        },
    },
    {
        label: 'فاطمه (Fatima) - AE',
        value: {
            language: 'ar-AE',
            voice: 'ar-AE-FatimaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'اسماعيل (Ismael) - DZ',
        value: {
            language: 'ar-DZ',
            voice: 'ar-DZ-IsmaelNeural',
            provider: 'azure',
        },
    },
    {
        label: 'أمينة (Amina) - DZ',
        value: {
            language: 'ar-DZ',
            voice: 'ar-DZ-AminaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'شَاكِر (Shakir) - EG',
        value: {
            language: 'ar-EG',
            voice: 'ar-EG-ShakirNeural',
            provider: 'azure',
        },
    },
    {
        label: 'سلمى (Salma) - EG',
        value: {
            language: 'ar-EG',
            voice: 'ar-EG-SalmaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'فهد (Fahed) - KW',
        value: {
            language: 'ar-KW',
            voice: 'ar-KW-FahedNeural',
            provider: 'azure',
        },
    },
    {
        label: 'نورا (Noura) - KW',
        value: {
            language: 'ar-KW',
            voice: 'ar-KW-NouraNeural',
            provider: 'azure',
        },
    },
    {
        label: 'عبدالله (Abdullah) - OM',
        value: {
            language: 'ar-OM',
            voice: 'ar-OM-AbdullahNeural',
            provider: 'azure',
        },
    },
    {
        label: 'عائشة (Aysha) - OM',
        value: {
            language: 'ar-OM',
            voice: 'ar-OM-AyshaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'حامد (Hamed) - SA',
        value: {
            language: 'ar-SA',
            voice: 'ar-SA-HamedNeural',
            provider: 'azure',
        },
    },
    {
        label: 'زارية (Zariyah) - SA',
        value: {
            language: 'ar-SA',
            voice: 'ar-SA-ZariyahNeural',
            provider: 'azure',
        },
    },

    {
        label: 'Tomáš',
        value: {
            language: 'cs-CZ',
            voice: 'cs-CZ_TomasU8',
            provider: 'mvoice',
        },
    },
    {
        label: 'Lenka',
        value: {
            language: 'cs-CZ',
            voice: 'cs-CZ_LenkaU8',
            provider: 'mvoice',
        },
    },
    {
        label: 'Jana',
        value: { language: 'cs-CZ', voice: 'cs-CZ_JanaU8', provider: 'mvoice' },
    },
    {
        label: 'Antonín',
        value: {
            language: 'cs-CZ',
            voice: 'cs-CZ-AntoninNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Vlasta',
        value: {
            language: 'cs-CZ',
            voice: 'cs-CZ-VlastaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Jiri',
        value: {
            language: 'cs-CZ',
            voice: '6FxLnDbRUt4y6CGhqpkl',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Hanka (beta)',
        value: {
            language: 'cs-CZ',
            voice: '12CHcREbuPdJY02VY7zT',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Ondřej – vypravěč',
        value: {
            language: 'cs-CZ',
            voice: 'nCmK9bolkZa2wzrAjnEe',
            provider: 'elevenlabs',
        },
    },

    {
        label: 'Thorsten - DE',
        value: {
            language: 'de-DE',
            voice: 'de-DE_ThorstenMuelerU8_v4.2',
            provider: 'mvoice',
        },
    },
    {
        label: 'Conrad - DE',
        value: {
            language: 'de-DE',
            voice: 'de-DE-ConradNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Christoph - DE',
        value: {
            language: 'de-DE',
            voice: 'de-DE-ChristophNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Katja - DE',
        value: {
            language: 'de-DE',
            voice: 'de-DE-KatjaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Amala - DE',
        value: {
            language: 'de-DE',
            voice: 'de-DE-AmalaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Lena - Cute German Voice',
        value: {
            language: 'de-DE',
            voice: 'XqTEUeXvEbbL4e30WfT0',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Amadeus',
        value: {
            language: 'de-DE',
            voice: 'y8FeN9lFTEmQOYCaE07F',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Jonas - AT',
        value: {
            language: 'de-AT',
            voice: 'de-AT-JonasNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Ingrid - AT',
        value: {
            language: 'de-AT',
            voice: 'de-AT-IngridNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Jan - CH',
        value: {
            language: 'de-CH',
            voice: 'de-CH-JanNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Leni - CH',
        value: {
            language: 'de-CH',
            voice: 'de-CH-LeniNeural',
            provider: 'azure',
        },
    },

    {
        label: 'Νέστορας (Nestoras)',
        value: {
            language: 'el-GR',
            voice: 'el-GR-NestorasNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Αθηνά (Athina)',
        value: {
            language: 'el-GR',
            voice: 'el-GR-AthinaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Cori - GB',
        value: {
            language: 'en-GB',
            voice: 'en-UK_CoriU16',
            provider: 'mvoice',
        },
    },
    {
        label: 'Ryan - GB',
        value: {
            language: 'en-GB',
            voice: 'en-GB-RyanNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Libby - GB',
        value: {
            language: 'en-GB',
            voice: 'en-GB-LibbyNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Brandon - US',
        value: {
            language: 'en-US',
            voice: 'en-US-BrandonNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Christopher - US',
        value: {
            language: 'en-US',
            voice: 'en-US-ChristopherNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Sara - US',
        value: {
            language: 'en-US',
            voice: 'en-US-SaraNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Jenny - US',
        value: {
            language: 'en-US',
            voice: 'en-US-JennyNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Katie Brown - Expressive',
        value: {
            language: 'en-GB',
            voice: 'gDnGxUcsitTxRiGHr904',
            provider: 'elevenlabs',
        },
    },

    {
        label: 'Alvaro - ES',
        value: {
            language: 'es-ES',
            voice: 'es-ES-AlvaroNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Elvira - ES',
        value: {
            language: 'es-ES',
            voice: 'es-ES-ElviraNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Serena AI',
        value: {
            language: 'es-CO',
            voice: 'IOyj8WtBHdke2FjQgGAr',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Alberto Rodriguez',
        value: {
            language: 'es-ES',
            voice: 'l1zE9xgNpUTaQCZzpNJa',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Martin Osborne 5',
        value: {
            language: 'es-ES',
            voice: 'D7dkYvH17OKLgp4SLulf',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Jorge - MX',
        value: {
            language: 'es-MX',
            voice: 'es-MX-JorgeNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Dalia - MX',
        value: {
            language: 'es-MX',
            voice: 'es-MX-DaliaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Gonzalo - CO',
        value: {
            language: 'es-CO',
            voice: 'es-CO-GonzaloNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Salome - CO',
        value: {
            language: 'es-CO',
            voice: 'es-CO-SalomeNeural',
            provider: 'azure',
        },
    },

    {
        label: 'Marek',
        value: {
            language: 'pl-PL',
            voice: 'pl-PL-MarekNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Agnieszka',
        value: {
            language: 'pl-PL',
            voice: 'pl-PL-AgnieszkaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Zofia',
        value: {
            language: 'pl-PL',
            voice: 'pl-PL-ZofiaNeural',
            provider: 'azure',
        },
    },

    {
        label: 'Дмитрий (Dmitry)',
        value: {
            language: 'ru-RU',
            voice: 'ru-RU-DmitryNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Светлана (Svetlana)',
        value: {
            language: 'ru-RU',
            voice: 'ru-RU-SvetlanaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Дария (Daryia)',
        value: {
            language: 'ru-RU',
            voice: 'ru-RU-DariyaNeural',
            provider: 'azure',
        },
    },

    {
        label: 'Ahmet',
        value: {
            language: 'tr-TR',
            voice: 'tr-TR-AhmetNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Emel',
        value: {
            language: 'tr-TR',
            voice: 'tr-TR-EmelNeural',
            provider: 'azure',
        },
    },

    {
        label: 'Oстап (Ostap)',
        value: {
            language: 'uk-UA',
            voice: 'uk-UA-OstapNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Поліна (Polina)',
        value: {
            language: 'uk-UA',
            voice: 'uk-UA-PolinaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Gabrijela',
        value: {
            language: 'hr-HR',
            voice: 'hr-HR-GabrijelaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Srecko',
        value: {
            language: 'hr-HR',
            voice: 'hr-HR-SreckoNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Ivan',
        value: {
            language: 'hr-HR',
            voice: 'vFQACl5nAIV0owAavYxE',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Viktoria',
        value: {
            language: 'sk-SK',
            voice: 'sk-SK-ViktoriaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Lukas',
        value: {
            language: 'sk-SK',
            voice: 'sk-SK-LukasNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Ona',
        value: {
            language: 'lt-LT',
            voice: 'lt-LT-OnaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Leonas',
        value: {
            language: 'lt-LT',
            voice: 'lt-LT-LeonasNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Noemi',
        value: {
            language: 'hu-HU',
            voice: 'hu-HU-NoemiNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Tamas',
        value: {
            language: 'hu-HU',
            voice: 'hu-HU-TamasNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Blessica',
        value: {
            language: 'fil-PH',
            voice: 'fil-PH-BlessicaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Angelo',
        value: {
            language: 'fil-PH',
            voice: 'fil-PH-AngeloNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Raquel',
        value: {
            language: 'pt-PT',
            voice: 'pt-PT-RaquelNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Duarte',
        value: {
            language: 'pt-PT',
            voice: 'pt-PT-DuarteNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Fernanda',
        value: {
            language: 'pt-PT',
            voice: 'pt-PT-FernandaNeural',
            provider: 'azure',
        },
    },

    {
        label: 'Nanami',
        value: {
            language: 'ja-JP',
            voice: 'ja-JP-NanamiNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Keita',
        value: {
            language: 'ja-JP',
            voice: 'ja-JP-KeitaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Aoi',
        value: {
            language: 'ja-JP',
            voice: 'ja-JP-AoiNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Daichi',
        value: {
            language: 'ja-JP',
            voice: 'ja-JP-DaichiNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Mayu',
        value: {
            language: 'ja-JP',
            voice: 'ja-JP-MayuNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Naoki',
        value: {
            language: 'ja-JP',
            voice: 'ja-JP-NaokiNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Shiori',
        value: {
            language: 'ja-JP',
            voice: 'ja-JP-ShioriNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Anu',
        value: {
            language: 'et-EE',
            voice: 'et-EE-AnuNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Kert',
        value: {
            language: 'et-EE',
            voice: 'et-EE-KertNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Alina',
        value: {
            language: 'ro-RO',
            voice: 'ro-RO-AlinaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Emil',
        value: {
            language: 'ro-RO',
            voice: 'ro-RO-EmilNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Elsa',
        value: {
            language: 'it-IT',
            voice: 'it-IT-ElsaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Isabella',
        value: {
            language: 'it-IT',
            voice: 'it-IT-IsabellaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Diego',
        value: {
            language: 'it-IT',
            voice: 'it-IT-DiegoNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Benigno',
        value: {
            language: 'it-IT',
            voice: 'it-IT-BenignoNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Calimero',
        value: {
            language: 'it-IT',
            voice: 'it-IT-CalimeroNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Cataldo',
        value: {
            language: 'it-IT',
            voice: 'it-IT-CataldoNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Fabiola',
        value: {
            language: 'it-IT',
            voice: 'it-IT-FabiolaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Fiamma',
        value: {
            language: 'it-IT',
            voice: 'it-IT-FiammaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Gianni',
        value: {
            language: 'it-IT',
            voice: 'it-IT-GianniNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Giuseppe',
        value: {
            language: 'it-IT',
            voice: 'it-IT-GiuseppeNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Imelda',
        value: {
            language: 'it-IT',
            voice: 'it-IT-ImeldaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Irma',
        value: {
            language: 'it-IT',
            voice: 'it-IT-IrmaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Lisandro',
        value: {
            language: 'it-IT',
            voice: 'it-IT-LisandroNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Palmira',
        value: {
            language: 'it-IT',
            voice: 'it-IT-PalmiraNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Pierina',
        value: {
            language: 'it-IT',
            voice: 'it-IT-PierinaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Rinaldo',
        value: {
            language: 'it-IT',
            voice: 'it-IT-RinaldoNeural',
            provider: 'azure',
        },
    },
    {
        label: 'AlessioMultilingual',
        value: {
            language: 'it-IT',
            voice: 'it-IT-AlessioMultilingualNeural',
            provider: 'azure',
        },
    },
    {
        label: 'IsabellaMultilingual',
        value: {
            language: 'it-IT',
            voice: 'it-IT-IsabellaMultilingualNeural',
            provider: 'azure',
        },
    },
    {
        label: 'MarcelloMultilingual',
        value: {
            language: 'it-IT',
            voice: 'it-IT-MarcelloMultilingualNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Kalina',
        value: {
            language: 'bg-BG',
            voice: 'bg-BG-KalinaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Borislav',
        value: {
            language: 'bg-BG',
            voice: 'bg-BG-BorislavNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Sophie',
        value: {
            language: 'sr-RS',
            voice: 'sr-RS-SophieNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Ivan',
        value: {
            language: 'sr-RS',
            voice: 'vFQACl5nAIV0owAavYxE',
            provider: 'elevenlabs',
        },
    },
    {
        label: 'Nicholas',
        value: {
            language: 'sr-RS',
            voice: 'sr-RS-NicholasNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Aigul',
        value: {
            language: 'kk-KZ',
            voice: 'kk-KZ-AigulNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Daulet',
        value: {
            language: 'kk-KZ',
            voice: 'kk-KZ-DauletNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Anila',
        value: {
            language: 'sq-AL',
            voice: 'sq-AL-AnilaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Ilir',
        value: {
            language: 'sq-AL',
            voice: 'sq-AL-IlirNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Marija',
        value: {
            language: 'mk-MK',
            voice: 'mk-MK-MarijaNeural',
            provider: 'azure',
        },
    },
    {
        label: 'Aleksandar',
        value: {
            language: 'mk-MK',
            voice: 'mk-MK-AleksandarNeural',
            provider: 'azure',
        },
    },
    {
        label: 'HoaiMy',
        value: {
            language: 'vi-VN',
            voice: 'vi-VN-HoaiMyNeural',
            provider: 'azure',
        },
    },
    {
        label: 'NamMinh',
        value: {
            language: 'vi-VN',
            voice: 'vi-VN-NamMinhNeural',
            provider: 'azure',
        },
    },
];
